import { useState } from 'preact/hooks';

function ExpandableText({ children, textLength = 'auto', maxLength = 50 }) {
    const [expanded, setExpanded] = useState(false);

    const toggleExpansion = () => {
        setExpanded(!expanded);
    };

    let str = children;

    if (children === null || children === undefined) {
        return null;
    }

    if (typeof children !== 'string') {
        // if it is a react element (e.g. a link) extract the text
        str = children.props.children;
    }

    if (textLength === 'auto') {
        textLength = str.toString().length;
    }

    return (
        <span onClick={toggleExpansion} style={{
            cursor: "pointer",
            textDecoration: "underline",
            textDecorationStyle: "dashed",
            textDecorationColor: "blue",
            textUnderlineOffset: "0.45em"
        }}>
            {expanded ? children : textLength > 50 ? `${str.slice(0, maxLength)}...` : children}
        </span>
    );
}

export default ExpandableText;
